import React, { useState, useEffect } from "react";
import "./style.scss";
import mentorIcon from "../../../../assets/svg/dashboard/mentor_app.svg";
import startupIcon from "../../../../assets/svg/dashboard/startup_application.svg";
import cohortIcon from "../../../../assets/svg/dashboard/cohort_application.svg";
import graphicSide from "../../../../assets/svg/dashboard/graphic_side.svg";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HorizontalBarChart from "../Chart";
import {
  getCountersList,
  getCountersSessions,
  getCountersHours,
  getCohortApplicationCounter,
  getAdminDashCohortGraphData,
  getAdminDashMentorGraphData,
} from "../AdminDashboard/AdminMentorAction/dependencies/action";
import { getCountersStartUpList } from "../StartupDashboard/dependencies/action";
import { useHistory } from "react-router-dom";
import parse from "html-react-parser";
import { initGA, logPageView } from "../../../../analytics";
import Chart from "react-apexcharts";
import { PRODUCTION_MOVE_HIDDEN } from "../../../common/constants/actionConstants";
import { firePopup } from "../../../common/popupForProduction";

const AdminDashboard = (props) => {
  const html = document.getElementsByTagName("html")[0];

  const {
    getCountersList,
    getCounter,
    getCountersStartUpList,
    getCounterStartUp,
    getSession,
    getCountersSessions,
    getCountersHours,
    getHours,
    getTableCounterData,
    getCohortApplicationCounter,
    getAdminDashCohortGraphData,
    getAdminDashMentorGraphData,
    cohortCounterData,
    mentorCounterData,
  } = props;
  // const [session, setSession] = useState(getSession);
  // const [hours, setHours] = useState(getHours);

  useEffect(() => {
    html.style.overflow = "auto";

    setTimeout(() => {
      // localStorage.removeItem("activitySummary");
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("startUpApplications");
      localStorage.removeItem("cohortApplication");
    }, 1000);
    try {
      initGA();
      window.GA_INITIALIZED = true;
      logPageView();
    } catch (error) {}
  }, [window]);

  const [selectedMenu, setSelectedMenu] = useState("adminMenu");
  const [LoginFormData, setLoginFormData] = useState();

  useEffect(() => {
    let params = {};
    let params2 = {
      status: "VERIFIED",
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      state: null,
      industry: null,
      function: null,
      stage: null,
      searchField: null,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    let params3 = {
      mentorId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 5,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getCohortApplicationCounter(params);
    getAdminDashCohortGraphData(params2);
    getAdminDashMentorGraphData(params3);
    // if (localStorage.getItem("mentorMenu")) {
    //   window.location.reload();
    // }
    // else if (localStorage.getItem("allMentorList")) {
    //   window.location.reload();
    // }
    // else {
    //   //
    // }

    try {
      let value = localStorage.getItem("SavedLoggedInData");
      let LoginData = JSON.parse(value);
      setLoginFormData(LoginData);
      if (LoginFormData?.role == "Admin") {
        setSelectedMenu("adminMenu");
      } else if (LoginFormData?.role == "Mentor") {
        setSelectedMenu("MentorMenu");
      }
    } catch (error) {}
  }, []);

  const [UpperdataMentor, setUpperdataMentor] = useState([
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #9e94c7", null],
    ["", 0, "color: #bdb1e3", null],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #e4c8f1", null],
    ["", 0, "color: #8072ab", null],
  ]);
  const Upperdata = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.totalSearch,
      "color: #9e94c7",
      null,
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.accepted,
      "color: #bdb1e3",
      null,
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.pending,
      "color: #d1b2de",
      null,
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.rejected,
      "color: #e4c8f1",
      null,
    ],
    ["", getCounterStartUp && getCounterStartUp.draft, "color: #8072ab", null],
  ];
  const mentorGraph1 = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.totalSearch,
      "color: #9e94c7",
      null,
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.accepted,
      "color: #bdb1e3",
      null,
    ],
    [
      "",
      getCounterStartUp && getCounterStartUp.accepted,
      "color: #d1b2de",
      null,
    ],
  ];
  // const [mentordata1, setmentordata1] = useState([
  //   [
  //     "",
  //     "",
  //     { role: "style" },
  //     {
  //       sourceColumn: 0,
  //       role: "annotation",
  //       type: "string",
  //       calc: "stringify",
  //     },
  //   ],
  //   ["", 0, "color: #e4c8f1", null],
  //   ["", 0, "color: #d1b2de", null],
  //   ["", 0, "color: #bdb1e3", null],
  // ]);
  const mentordata1 = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
  ];
  const mentordata2 = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
  ];

  const mentordata3 = [
    [
      "",
      "",
      { role: "style" },
      {
        sourceColumn: 0,
        role: "annotation",
        type: "string",
        calc: "stringify",
      },
    ],
    ["", 0, "color: #e4c8f1", null],
    ["", 0, "color: #d1b2de", null],
    ["", 0, "color: #bdb1e3", null],
  ];
  useEffect(() => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      state: "", // optional
      industry: "", // optional
      function: "", // optional
      stage: "", // optional
    };
    getCountersList(params);

    getCountersSessions({});
    getCountersHours({});
  }, []);
  useEffect(() => {
    let params = {
      requestedBy: "",
    };
    getCountersStartUpList(params);
  }, []);
  useEffect(() => {
    let data = [
      [
        "",
        "",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "style",
          type: "string",
          calc: "stringify",
        },
      ],
      ["", getCounter ? getCounter.total : 0, "color: #9e94c7", null],
      ["", getCounter ? getCounter.approved : 0, "color: #bdb1e3", null],
      ["", getCounter ? getCounter.pending : 0, "color: #d1b2de", null],
      ["", getCounter ? getCounter.rejected : 0, "color: #e4c8f1", null],
      ["", getCounter ? getCounter.draft : 0, "color: #8072ab", null],
    ];
    setUpperdataMentor(data);
    let mentorRequest = [
      [
        "",
        "",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
      ["", getCounter ? getCounter.approved : 0, "color: #d1b2de", "test"],
      ["", getCounter ? 0 : 0, "color: #d1b2de", null],
      ["", getCounter ? getCounter.total : 0, "color: #9e94c7", null],
    ];
  }, []);
  const history = useHistory();
  const ViewApplication = () => {
    history.push({
      pathname: "/view-application",
    });
  };

  const seriesLabels = [
    "Total Applications",
    "Total Approved",
    "Total Pending",
    "Total Rejected",
    "Total Drafts",
  ];

  const startupLabels = [
    "Total Requests",
    "Total Accepted",
    "Total Pending",
    "Total Declined",
    "Total Drafts",
  ];

  const startupHours = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
  ];

  const startupSessions = [
    "Till Date Scheduled",
    "Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming",
  ];

  const cohortLabels = [
    "Total Applications",
    "Total Approved",
    "Total Pending",
    "Total Rejected",
    "Total Drafts",
  ];

  const mentorRequestsLabels = [
    "Total Requirement",
    "Total Requested",
    "Total Accepted",
    "Total Mentorships",
  ];
  const cohortSessionHoursLabels = [
    "Till Date Scheduled",
    "  Till Date Completed",
    "This Quarter Scheduled",
    "This Quarter Completed",
    "Upcoming"
  ];

  const seriesLabelColors = [
    "#9e94c7",
    "#bdb1e3",
    "#d1b2de",
    "#d3a6e8",
    "#8072ab",
  ];

  const options = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          seriesLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const options2 = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          mentorRequestsLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };
  const optionsCohortSessionHours = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          cohortSessionHoursLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };
  const optionshours = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          startupHours[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const optionsessions = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          startupSessions[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };

  const optionsStartup = {
    chart: {
      type: "bar",
      height: 300,
    },
    plotOptions: {
      bar: {
        borderRadius: 0,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: [
      function ({ value, seriesIndex, dataPointIndex, w }) {
        // if (dataPointIndex == 8) {
        //   return "#7E36AF";
        // } else {
        //   return "#D9534F";
        // }
        return seriesLabelColors[dataPointIndex];
      },
    ],
    grid: {
      show: true, // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: true, //or just here to disable only x axis grids
        },
      },
      yaxis: {
        lines: {
          show: false, //or just here to disable only y axis
        },
      },
    },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        return (
          '<div class="arrow_box">' +
          "<span>" +
          // w.globals.labels[dataPointIndex] +
          startupLabels[dataPointIndex] +
          ": " +
          (Math.round(series[seriesIndex][dataPointIndex] * 100) / 100).toFixed(
            2
          ) +
          "</span>" +
          "</div>"
        );
      },
    },

    xaxis: {
      categories: [
        // "Total Application",
        // "Total Approved",
        // "Total Pending",
        // "Total Rejected",
        // "Total Drafts",
        "",
        "",
        "",
        "",
        "",
        // "France",
        // "Japan",
        // "United States",
        // "China",
        // "Germany",
      ],
    },
  };
  const seriesMentor = [
    {
      data: [
        getCounter ? getCounter.total : 0,
        getCounter ? getCounter.approved : 0,
        getCounter ? getCounter.pending : 0,
        getCounter ? getCounter.rejected : 0,
        getCounter ? getCounter.draft : 0,
      ],
    },
  ];
  const seriesStartup = [
    {
      data: [
        getCounterStartUp ? getCounterStartUp.total : 0,
        getCounterStartUp ? getCounterStartUp.accepted : 0,
        getCounterStartUp ? getCounterStartUp.pending : 0,
        getCounterStartUp ? getCounterStartUp.rejected : 0,
        getCounterStartUp ? getCounterStartUp.draft : 0,
      ],
    },
  ];
  // getTableCounterData
  const seriesCohort = [
    {
      data: [
        getTableCounterData ? getTableCounterData.total : 0,
        getTableCounterData ? getTableCounterData.approved : 0,
        getTableCounterData ? getTableCounterData.pending : 0,
        getTableCounterData ? getTableCounterData.rejected : 0,
        getTableCounterData ? getTableCounterData.draft : 0,
      ],
    },
  ];
  const seriesMentorRequests = [
    {
      data: [
        // 0,0,0,
        getCounterStartUp ? getCounterStartUp.totalSearch : 0,
        getCounterStartUp ? getCounterStartUp.total : 0,
        getCounterStartUp ? getCounterStartUp.accepted : 0,
        getCounterStartUp ? getCounterStartUp.mentorships : 0,
        0,
      ],
    },
  ];
  const seriesCohortHours = [
    {
      data: [
        // 0,0,0,
        cohortCounterData ? cohortCounterData.TillDateTotalHours : 0,
        cohortCounterData ? cohortCounterData.TillDateCompletedHours : 0,
        cohortCounterData ? cohortCounterData.ThisQuarterScheduledHours : 0,
        cohortCounterData ? cohortCounterData.ThisQuarterCompletedHours : 0,
        cohortCounterData ? cohortCounterData.UpcomingHours : 0,
      ],
    },
  ];
  const seriesCohortSession = [
    {
      data: [
        // 0,0,0,
        cohortCounterData ? cohortCounterData.TillDateTotalSessions : 0,
        cohortCounterData ? cohortCounterData.TillDateCompletedSessions : 0,
        cohortCounterData ? cohortCounterData.ThisQuarterScheduledSessions : 0,
        cohortCounterData ? cohortCounterData.ThisQuarterCompletedSessions : 0,
        cohortCounterData ? cohortCounterData.TillDateUpcomingSessions : 0,
      ],
    },
  ];
  const seriesTotalMentorshipHours = [
    {
      data: [
        // 0,0,0,
        mentorCounterData ? 
        parseFloat(
          mentorCounterData.TillDateScheduledHours
        ).toFixed(2) 
        // Math.floor(mentorCounterData.TillDateScheduledHours) 
        : 0,
        mentorCounterData ? 
        parseFloat(
          mentorCounterData.TillDateCompletedHours
        ).toFixed(2) 
        // Math.floor(mentorCounterData.TillDateCompletedHours) 
        : 0,
        mentorCounterData ?
        parseFloat(
          mentorCounterData.ThisQuarterScheduledHours
        ).toFixed(2) 
        // Math.floor(mentorCounterData.ThisQuarterScheduledHours) 
        : 0,
        mentorCounterData ?  parseFloat(
          mentorCounterData.ThisQuarterCompletedHours
        ).toFixed(2) 
          // Math.floor(mentorCounterData.ThisQuarterCompletedHours) 
          : 0,
        mentorCounterData ? 
        parseFloat(
          mentorCounterData.UpcomingHours
        ).toFixed(2) 
        //  Math.floor(mentorCounterData.UpcomingHours) 
         : 0,
      ],
    },
  ];
  const seriesTotalMentorshipSession = [
    {
      data: [
        // 0,0,0,
        mentorCounterData ? mentorCounterData.TillDateTotalSessions : 0,
        mentorCounterData ? mentorCounterData.TillDateCompletedSessions : 0,
        mentorCounterData ? mentorCounterData.ThisQuarterScheduledSessions : 0,
        mentorCounterData ? mentorCounterData.ThisQuarterCompletedSessions : 0,
        mentorCounterData ? mentorCounterData.TillDateUpcomingSessions : 0,
      ],
    },
  ];
  //
  const seriesMentorHours = [
    {
      data: [
        getHours ? parseFloat(getHours.tillDateScheduledHours).toFixed(2) : 0,
        getHours ? parseFloat(getHours.tillDateCompletedHours).toFixed(2) : 0,
        getHours ? parseFloat(getHours.quarterScheduledHours).toFixed(2) : 0,
        getHours ? parseFloat(getHours.quarterCompletedHours).toFixed(2) : 0,
        getHours ? parseFloat(getHours.upcomingHours).toFixed(2) : 0,
      ],
    },
  ];
  const seriesMentorSessions = [
    {
      // data: [0, 0, 0, 0, 0],
      data: [
        getSession ? getSession.tillDateScheduled : 0,
        getSession ? getSession.tillDateCompleted : 0,
        getSession ? getSession.quarterScheduled : 0,
        getSession ? getSession.quarterCompleted : 0,
        getSession ? getSession.upcoming : 0,
      ],
    },
  ];
  // useEffect(() => {
  //   console.log("cohortCounterData", cohortCounterData);
  // }, [cohortCounterData]);
  // useEffect(() => {
  //   console.log("mentorCounterData", mentorCounterData);
  // }, [mentorCounterData]);
  return (
    <>
      <div className="dashboard-adminfor">
        <div className="dashboard-main2">
          <h3 className="sub-heading fadeInDown wow homepageSecondHeader">
            MAARG Portal by Startup India
          </h3>
          <h3 className="dashboard-sub-heading fadeInDown wow homepageFirstHeader">
            ADMIN DASHBOARD
          </h3>

          <h3 className="dashboard-sub-heading fadeInDown wow homepageSecondHeader">
            Application Status
          </h3>
          <ul className="dashboard-cards">
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="dashboard-card-mentor">
                  <div className="dashboard-card_image">
                    <img src={mentorIcon} />
                  </div>
                  <div className="dashboard-card_content md-p-0 sm-p-0 lg-p-0">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      MENTOR APPLICATIONS
                    </h3>
                    {/* <HorizontalBarChart chartData={UpperdataMentor} /> */}
                    <div style={{ marginTop: "30px" }}>
                      <Chart
                        options={options}
                        series={seriesMentor}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>

                    <div className="inner-dashboard-view md-p-0 sm-p-0 lg-p-0">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Total Applications :{" "}
                          <span>{getCounter && getCounter.total}</span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription">
                          Total Approved :{" "}
                          <span>{getCounter && getCounter.approved}</span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription">
                          Total Pending :{" "}
                          <span>{getCounter && getCounter.pending}</span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription">
                          Total Rejected :{" "}
                          <span>{getCounter && getCounter.rejected}</span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Total Drafts :{" "}
                          <span>{getCounter && getCounter.draft}</span>
                        </p>
                      </div>
                    </div>

                    <div
                      className="dashboard-blue-btn top-btn md-p-0 sm-p-0 lg-p-0 newuserTooltip "
                      style={{
                        width: "100%",
                        position: "relative",
                      }}
                      onClick={() => {
                        localStorage.setItem("mentorMenu", "mentorMenu");
                        localStorage.setItem("showPending", "showPending");
                        window.location.reload();
                      }}
                    >
                      <span
                        className="blue-link-dashboard text-wrap md-p-0 sm-p-0 lg-p-0 link-dash  adminerticular"
                        onClick={() => {
                          localStorage.setItem("mentorMenu", "mentorMenu");
                          localStorage.setItem("showPending", "showPending");
                          window.location.reload();
                        }}
                      >
                        {" "}
                        APPROVE PENDING APPLICATIONS
                      </span>
                      <span className="tooltiptext dashboardbtn tooltip-bottom">
                        Click to View Pending Applications
                      </span>
                    </div>
                    <div
                      className="dashboard-purple-btn top-btn newuserTooltip"
                      style={{
                        width: "100%",
                      }}
                      onClick={() => {
                        localStorage.setItem("mentorMenu", "mentorMenu");
                        window.location.reload();
                      }}
                    >
                      <span
                        className="blue-link-dashboard link-dash adminButtons-dash"
                        onClick={() => {
                          // setSelectedMenu("mentorMenu")
                          localStorage.setItem("mentorMenu", "mentorMenu");
                          window.location.reload();
                        }}
                        style={{
                          paddingRight: "0px",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        VIEW ALL APPLICATIONS
                      </span>
                      <span className="tooltiptext dashboardbtn tooltip-bottom">
                        Click to View All Applications
                      </span>
                    </div>
                  </div>
                </div>
                <div className="newuserTooltip">
                  <div className="bigBlueBtnDiv  ">
                    <img
                      style={{ width: "auto", height: "120px" }}
                      src={graphicSide}
                    />

                    <div
                      className="dashboard-round-iconText top-btn "
                      onClick={() => {
                        localStorage.setItem("allMentorList", "allMentorList");
                        // document.body.style.overflow = "hidden"
                        window.location.reload();
                        history.push({
                          state: {
                            fromModule: "mentorDashboardHome",
                          },
                        });
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <p>{parse("MENTOR<br> LIST")}</p>
                    </div>
                  </div>
                  <span className="tooltiptext dashboardbtnMentor tooltip-bottom">
                    Click to View Mentor List
                  </span>
                </div>
              </div>
            </li>
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="dashboard-card-startupMentorHome">
                  <div className="dashboard-card_image">
                    <img src={startupIcon} />
                  </div>
                  <div className="dashboard-card_content">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      STARTUP REQUESTS
                    </h3>
                    {/* <HorizontalBarChart chartData={Upperdata} /> */}
                    <div style={{ marginTop: "30px" }}>
                      <Chart
                        options={optionsStartup}
                        series={seriesStartup}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Total Requests :{" "}
                          <span>
                            {getCounterStartUp && getCounterStartUp.total}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription">
                          Total Accepted :{" "}
                          <span>
                            {getCounterStartUp && getCounterStartUp.accepted}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription">
                          Total Pending :{" "}
                          <span>
                            {getCounterStartUp && getCounterStartUp.pending}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription">
                          Total Declined :{" "}
                          <span>
                            {getCounterStartUp && getCounterStartUp.rejected}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="squareempty"></div>
                        <p className="homepageFifthDescription">
                          {/* Total Drafts :{" "}
                          <span>
                            {getCounterStartUp && getCounterStartUp.draft}
                          </span> */}
                        </p>
                      </div>
                    </div>

                    <div
                      className="dashboard-blue-btn top-btn newuserTooltip"
                      style={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        localStorage.setItem(
                          "startUpApplications",
                          "startUpApplications"
                        );
                        // document.body.style.overflow = "hidden"
                        window.location.reload();
                        history.push({
                          state: {
                            fromModule: "mentorDashboardHome",
                            id: LoginFormData.id,
                            requestStatus: "pending",
                          },
                        });
                      }}
                    >
                      <div
                        className="blue-link-dashboard link-dash adminButtons-dash adminerticular3"
                        style={{
                          paddingRight: "0px",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        PENDING REQUESTS
                      </div>
                      <span className="tooltiptext dashboardbtn tooltip-bottom">
                        Click to View Pending Requests
                      </span>
                    </div>
                    {LoginFormData && (
                      <div
                        className="dashboard-purple-btn top-btn newuserTooltip"
                        style={{
                          width: "100%",
                          cursor: "pointer",
                          marginTop: "2px",
                        }}
                        onClick={() => {
                          localStorage.setItem(
                            "startUpApplications",
                            "startUpApplications"
                          );
                          // document.body.style.overflow = "hidden"
                          window.location.reload();
                          history.push({
                            state: {
                              fromModule: "mentorDashboardHome",
                              id: LoginFormData.id,
                              requestStatus: "viewAll",
                            },
                          });
                        }}
                      >
                        <div
                          className="blue-link-dashboard link-dash adminButtons-dash"
                          style={{
                            paddingRight: "0px",
                            cursor: "pointer",
                            fontWeight: "600",
                            marginBottom: "2px",
                          }}
                        >
                          {" "}
                          VIEW ALL REQUESTS
                        </div>
                        <span className="tooltiptext dashboardbtn tooltip-bottom">
                          Click to View All Requests
                        </span>
                        {/* <span className="tooltiptext3">
                          Please stay tuned, this function will be enabled shortly
                          after the launch of Startup onboarding process.
                        </span> */}
                      </div>
                    )}
                  </div>
                </div>
                <div className="newuserTooltip">
                  <div className="bigBlueBtnDiv">
                    <img
                      style={{ width: "auto", height: "120px" }}
                      src={graphicSide}
                    />
                    <div
                      className="dashboard-round-iconText top-btn"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        localStorage.setItem(
                          "allStartupList",
                          "allStartupList"
                        );
                        // document.body.style.overflow = "hidden"
                        window.location.reload();
                        history.push({
                          state: {
                            fromModule: "mentorDashboardHome",
                          },
                        });
                        // history.push('/startup-list');
                      }}
                    >
                      <p>{parse("STARTUP<br> LIST")}</p>
                      {/* <span className="tooltiptext3">
                      Please stay tuned, this function will be enabled shortly
                      after the launch of Startup onboarding process.
                    </span> */}
                    </div>
                  </div>
                  <span className="tooltiptext dashboardbtnMentor tooltip-bottom">
                    Click to View Startup List
                  </span>
                </div>
              </div>
            </li>
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="dashboard-card-cohort">
                  <div className="dashboard-card_image">
                    <img src={cohortIcon} />
                  </div>
                  <div className="dashboard-card_content">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      COHORT APPLICATIONS
                    </h3>
                    {/* <HorizontalBarChart chartData={Upperdata} /> */}
                    <div style={{ marginTop: "30px" }}>
                      <Chart
                        options={options}
                        series={seriesCohort}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>

                    <div className="inner-dashboard-view">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Total Applications :{" "}
                          <span>
                            {getTableCounterData &&
                              Math.abs(getTableCounterData.total)}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription">
                          Total Approved :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {getTableCounterData &&
                                Math.abs(getTableCounterData.approved)}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription">
                          Total Pending :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {getTableCounterData &&
                                Math.abs(getTableCounterData.pending)}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription">
                          Total Rejected :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {getTableCounterData &&
                                Math.abs(getTableCounterData.rejected)}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Total Drafts :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {getTableCounterData &&
                                Math.abs(getTableCounterData.draft)}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>

                    <div
                      className="dashboard-blue-btn top-btn  newuserTooltip"
                      style={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (PRODUCTION_MOVE_HIDDEN) {
                          firePopup(
                            "Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process."
                          );
                          return;
                        }
                        localStorage.setItem(
                          "cohortApplication",
                          "cohortApplication"
                        );
                        window.location.reload();
                        history.push({
                          state: {
                            fromModule: "mentorDashboardHome",
                            requestStatus:"pending"
                          },
                        });
                        // props.setSelectedMenu("cohortApplication");
                        // history.push("/dashboard");
                      }}
                    >
                      <div
                        className="blue-link-dashboard link-dash adminButtons-dash adminerticular2"
                        style={{
                          paddingRight: "0px",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        {" "}
                        APPROVE PENDING APPLICATIONS
                      </div>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{
                          fontFamily: "Montserrat",
                          left: "105px",
                          top: "55px",
                          width: "250px",
                          padding: "0px 10px",
                        }}
                      >
                        Click to View Pending Applications
                      </span>
                    </div>
                    <div
                      className="dashboard-purple-btn top-btn newuserTooltip "
                      style={{
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (PRODUCTION_MOVE_HIDDEN) {
                          firePopup(
                            "Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process."
                          );

                          return;
                        }
                        localStorage.setItem(
                          "cohortApplication",
                          "cohortApplication"
                        );
                        history.push({
                          state: {
                            fromModule: "mentorDashboardHome",
                            requestStatus:"viewAll"
                          },
                        });
                        window.location.reload();
                        // props.setSelectedMenu("cohortApplication");
                        // history.push("/dashboard");
                      }}
                    >
                      <div
                        className="blue-link-dashboard link-dash adminButtons-dash"
                        style={{
                          paddingRight: "0px",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                      >
                        VIEW ALL APPLICATIONS
                      </div>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{
                          fontFamily: "Montserrat",
                          left: "115px",
                          top: "55px",
                          width: "230px",
                          padding: "0px 10px",
                        }}
                      >
                        Click to View All Applications
                      </span>
                    </div>
                  </div>
                </div>
                <div className="newuserTooltip">
                  <div
                    className="bigBlueBtnDiv "
                    onClick={() => {
                      if (PRODUCTION_MOVE_HIDDEN) {
                        firePopup(
                          "Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process."
                        );

                        return;
                      }
                      localStorage.setItem("cohortProgram", "cohortProgram");
                      window.location.reload();
                      history.push({
                        state: {
                          fromModule: "mentorDashboardHome",
                        },
                      });
                      // setSelectedMenu("cohortProgram");
                      // history.push("/dashboard");
                    }}
                  >
                    <img
                      style={{ width: "auto", height: "120px" }}
                      src={graphicSide}
                    />
                    <div
                      className="dashboard-round-iconText top-btn "
                      style={{ cursor: "pointer" }}
                    >
                      <p>{parse("COHORT<br> LIST")}</p>
                    </div>
                  </div>
                  <span className="tooltiptext dashboardbtnMentor tooltip-bottom">
                    Click to View Cohort List
                  </span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="dashboard-mentor-main">
          <h3 className="dashboard-sub-heading homepageSecondHeader">
            ONE TO ONE MENTORSHIPS
          </h3>
          <ul className="dashboard-cards">
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="rowC dashboard-card-mentor-bottom">
                  <div className="dashboard-card_content md-p-0 sm-p-0 lg-p-0 adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription cardheding-mentorship">
                      MENTORSHIP REQUIREMENT
                    </h3>
                    {/* <HorizontalBarChart
                      chartData={mentorGraph1}
                      actionData="mentorRequests"
                    /> */}
                    <div
                      className="adminChartMentorship1"
                      // style={{ marginTop: "29px" }}
                    >
                      
                      <Chart
                        options={options2}
                        series={seriesMentorRequests}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div
                      className="inner-dashboard-view md-p-0 sm-p-0 lg-p-0"
                      style={{ marginTop: "2rem" }}
                    >
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Total Requirement :{" "}
                          {/* {PRODUCTION_MOVE_HIDDEN ?<span>0</span>  : */}
                          <span>
                            {getCounterStartUp && getCounterStartUp.totalSearch}
                          </span>
                          {/* } */}
                          {/* <span>00</span> */}
                        </p>
                      </div>

                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Total Requested :{" "}
                          {/* {PRODUCTION_MOVE_HIDDEN ?<span>0</span>  : */}
                          <span>
                            {getCounterStartUp && getCounterStartUp.total}
                          </span>
                          {/* } */}
                          {/* <span>00</span> */}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription">
                          Total Accepted :{" "}
                          {/* {PRODUCTION_MOVE_HIDDEN ?<span>0</span>  : */}
                          <span>
                            {getCounterStartUp && getCounterStartUp.accepted}
                          </span>
                          {/* } */}
                          {/* <span>00</span> */}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription">
                          Total Mentorships :{" "}
                          {/* {PRODUCTION_MOVE_HIDDEN ?<span>0</span>  : */}
                          <span>
                            {getCounterStartUp && getCounterStartUp.mentorships}
                          </span>
                          {/* } */}
                          {/* <span>00</span> */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div
                  className="dashboard-card-startup-bottom"
                  style={{ paddingBottom: "1.5rem" }}
                >
                  <div className="dashboard-card_content adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      MENTORSHIP HOURS
                    </h3>

                    {/* <HorizontalBarChart
                      chartData={mentordata2}
                      actionData="mentorHours"
                    /> */}
                    <div className="chart4TopFix">
                      <Chart
                        options={optionshours}
                        series={seriesMentorHours}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop5">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Till Date Scheduled :{" "}
                          <span>
                            {getHours !== undefined
                              ? parseFloat(
                                  getHours.tillDateScheduledHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          <span>
                            {getHours !== undefined
                              ? parseFloat(
                                  getHours.tillDateCompletedHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          <span>
                            {getHours !== undefined
                              ? parseFloat(
                                  getHours.quarterScheduledHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          <span>
                            {getHours !== undefined
                              ? parseFloat(
                                  getHours.quarterCompletedHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          <span>
                            {getHours !== undefined
                              ? parseFloat(getHours.upcomingHours).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="dashboard-card-cohort-bottom">
                  <div className="dashboard-card_content adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      MENTORSHIP SESSIONS
                    </h3>

                    {/* <HorizontalBarChart
                      chartData={mentordata3}
                      actionData="mentorSessions"
                    /> */}
                    <div className="chart4TopFix">
                      <Chart
                        options={optionsessions}
                        series={seriesMentorSessions}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop5">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Scheduled :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {getSession !== undefined
                                ? getSession.tillDateScheduled
                                : 0}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {" "}
                              {getSession !== undefined
                                ? getSession.tillDateCompleted
                                : 0}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {" "}
                              {getSession !== undefined
                                ? getSession.quarterScheduled
                                : 0}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {" "}
                              {getSession !== undefined
                                ? getSession.quarterCompleted
                                : 0}
                            </span>
                          )}
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          {PRODUCTION_MOVE_HIDDEN ? (
                            <span>0</span>
                          ) : (
                            <span>
                              {" "}
                              {getSession !== undefined
                                ? getSession.upcoming
                                : 0}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="dashboard-mentor-main">
          <h3 className="dashboard-sub-heading homepageSecondHeader">
            COHORT GROUP SESSIONS
          </h3>
          <ul className="dashboard-cards">
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="rowC dashboard-card-mentor-bottom">
                  <div className="dashboard-card_content md-p-0 sm-p-0 lg-p-0 adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription cardheding-mentorship">
                      GROUP SESSION HOURS
                    </h3>
                    {/* <HorizontalBarChart
                      chartData={mentorGraph1}
                      actionData="mentorRequests"
                    /> */}
                    <div
                      className="adminChartMentorship110"
                      // style={{ marginTop: "29px" }}
                    >
                      <Chart
                        options={optionsCohortSessionHours}
                        series={seriesCohortHours}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop52">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Till Date Scheduled :{" "}
                          <span>
                            {cohortCounterData !== undefined
                              ? parseFloat(
                                cohortCounterData.TillDateTotalHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          <span>
                          {cohortCounterData !== undefined
                              ? parseFloat(
                                cohortCounterData.TillDateCompletedHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          <span>
                          {cohortCounterData !== undefined
                              ? parseFloat(
                                cohortCounterData.ThisQuarterScheduledHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          <span>
                          {cohortCounterData !== undefined
                              ? parseFloat(
                                cohortCounterData.ThisQuarterCompletedHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          <span>
                          {cohortCounterData !== undefined
                              ? parseFloat(
                                cohortCounterData.UpcomingHours
                                ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div
                  className="dashboard-card-startup-bottom"
                  style={{ paddingBottom: "1.5rem" }}
                >
                  <div className="dashboard-card_content adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      NO. OF GROUP SESSIONS
                    </h3>

                    {/* <HorizontalBarChart
                      chartData={mentordata2}
                      actionData="mentorHours"
                    /> */}
                    <div className="chart42TopFix">
                      <Chart
                        options={optionsCohortSessionHours}
                        series={seriesCohortSession}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop52">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Till Date Scheduled :{" "}
                          <span>
                          {cohortCounterData !== undefined ?
                              // ? parseFloat(
                                cohortCounterData.TillDateTotalSessions
                                // ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          <span>
                          {cohortCounterData !== undefined ?
                              // ? parseFloat(
                                cohortCounterData.TillDateCompletedSessions
                                // ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          <span>
                          {cohortCounterData !== undefined ?
                              // ? parseFloat(
                                cohortCounterData.ThisQuarterScheduledSessions
                                // ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          <span>
                          {cohortCounterData !== undefined ?
                              // ? parseFloat(
                                cohortCounterData.ThisQuarterCompletedSessions
                                // ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          <span>
                          {cohortCounterData !== undefined ?
                              // ? parseFloat(
                                cohortCounterData.TillDateUpcomingSessions
                                // ).toFixed(2)
                              : 0}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}></div>
            </li>
          </ul>
        </div>
        <div className="dashboard-mentor-main">
          <h3 className="dashboard-sub-heading homepageSecondHeader">
            TOTAL MENTORSHIPS
          </h3>
          <ul className="dashboard-cards">
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div className="rowC dashboard-card-mentor-bottom">
                  <div className="dashboard-card_content md-p-0 sm-p-0 lg-p-0 adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription cardheding-mentorship">
                      MENTORSHIP HOURS
                    </h3>
                    {/* <HorizontalBarChart
                      chartData={mentorGraph1}
                      actionData="mentorRequests"
                    /> */}
                    <div
                      className="adminChartMentorship110"
                      // style={{ marginTop: "29px" }}
                    >
                      <Chart
                        options={optionsCohortSessionHours}
                        series={seriesTotalMentorshipHours}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop522">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Till Date Scheduled :{" "}
                          <span>
                            {
                              mentorCounterData && parseFloat(
                                mentorCounterData.TillDateScheduledHours
                              ).toFixed(2) 
                            }
                            {/* {getHours !== undefined
                              ? parseFloat(
                                  getHours.tillDateScheduledHours
                                ).toFixed(2)
                              : 0} */}

                              
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          <span>
                          {
                              mentorCounterData && parseFloat(
                                mentorCounterData.TillDateCompletedHours
                              ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          <span>
                          {
                              mentorCounterData && parseFloat(
                                mentorCounterData.ThisQuarterScheduledHours
                              ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          <span>
                          {
                              mentorCounterData && parseFloat(
                                mentorCounterData.ThisQuarterCompletedHours
                              ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          <span>
                          {
                              mentorCounterData && parseFloat(
                                mentorCounterData.UpcomingHours
                              ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}>
                <div
                  className="dashboard-card-startup-bottom"
                  style={{ paddingBottom: "1.5rem" }}
                >
                  <div className="dashboard-card_content adminHoursBoxFix">
                    <h3 className="dashboard-card-heading homepageFourthDescription">
                      MENTORSHIP SESSIONS
                    </h3>

                    {/* <HorizontalBarChart
                      chartData={mentordata2}
                      actionData="mentorHours"
                    /> */}
                    <div className="chart5TopFix">
                      <Chart
                        options={optionsCohortSessionHours}
                        series={seriesTotalMentorshipSession}
                        type="bar"
                        height={200}
                        // width={500} height={320}
                      />
                    </div>
                    <div className="inner-dashboard-view textBoxTop5">
                      <div className="rowC">
                        <div className="square1"></div>
                        <p className="homepageFifthDescription">
                          Till Date Scheduled :{" "}
                          <span>
                          {
                              mentorCounterData &&
                              //  parseFloat(
                                mentorCounterData.TillDateTotalSessions
                              // ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square2"></div>
                        <p className="homepageFifthDescription ">
                          Till Date Completed :{" "}
                          <span>
                          {
                              mentorCounterData &&
                              //  parseFloat(
                                mentorCounterData.TillDateCompletedSessions
                              // ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square3"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Scheduled :{" "}
                          <span>
                          {
                              mentorCounterData &&
                              //  parseFloat(
                                mentorCounterData.ThisQuarterScheduledSessions
                              // ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square4"></div>
                        <p className="homepageFifthDescription ">
                          This Quarter Completed :{" "}
                          <span>
                          {
                              mentorCounterData &&
                              //  && parseFloat(
                                mentorCounterData.ThisQuarterCompletedSessions
                              // ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                      <div className="rowC">
                        <div className="square5"></div>
                        <p className="homepageFifthDescription">
                          Upcoming :{" "}
                          <span>
                          {
                              mentorCounterData && 
                              // parseFloat(
                                mentorCounterData.TillDateUpcomingSessions
                              // ).toFixed(2) 
                            }
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>

            <li className="dashboard-cards_item">
              <div style={{ width: "100%" }}></div>
            </li>
          </ul>
        </div>
        <div
          className="dashboard-purple-btn top-btn view-mentorshipd"
          style={{
            // width: "100%",
            cursor: "pointer",
          }}
          onClick={() => {
            if (PRODUCTION_MOVE_HIDDEN) {
              firePopup();
              return;
            }
            localStorage.setItem(
              "startupMentorAllMentorships",
              "startupMentorAllMentorships"
            );
            window.location.reload();

            // setSelectedMenu("allMentorsMentorship")
            // onClick={()=>{
            //   //
            //   // localStorage.setItem("allMentorships", "allMentorships");
            //   //               window.location.reload();
            //   props.setSelectedMenu("startupMentorAllMentorships")
            //   // history.push("/dashboard")
          }}
        >
          <div className="newuserTooltip">
            <div
              className="blue-link-dashboard adminviewmwntorshi"
              style={{
                paddingRight: "0px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              VIEW MENTORSHIPS
            </div>
            <span
              className="tooltiptext  tooltip-bottom"
              style={{
                padding: "-1px",
                top: "40px",
                left: "130px",
                width: "200px",
              }}
            >
              Click to View Mentorships
            </span>
          </div>
          {/* <span className="tooltiptextMentorship">
            Please stay tuned, this function will be enabled shortly after the
            launch of Startup onboarding process.
          </span> */}
        </div>

        {/* <div>
          <div className="summaryButton">
            <div className="dashboard-admin-mentor">
              <p
                style={{
                  color: "#fff !important",
                  fontSize: "20px",
                  fontFamily: "Montserrat",
                  fontWeight: "600",
                  color: "#fff",
                  cursor: "default",
                }}
              >
                <div className="top-btn tooltipicon">
                  <a className="interested-link">
                    VIEW MENTORSHIP ENAGAGEMENT SUMMARY{" "}
                  </a>
                  <span className="tooltiptext3">
                    Please stay tuned, this function will be enabled shortly
                    after the launch of Startup onboarding process.
                  </span>
                </div>
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    getCounter: state.AdminMentorReducer.getCountersList.data,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getSession: state.AdminMentorReducer.getCountersSessions.data,
    getHours: state.AdminMentorReducer.getCountersHours.data,
    cohortCounterData: state.AdminMentorReducer.adminDashCohortCounter,
    mentorCounterData: state.AdminMentorReducer.adminDashMentorCounter,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
  };
};

export default connect(mapStateToProps, {
  getCountersList,
  getCountersStartUpList,
  getCountersSessions,
  getCountersHours,
  getCohortApplicationCounter,
  getAdminDashCohortGraphData,
  getAdminDashMentorGraphData,
})(withRouter(AdminDashboard));
